import { render, staticRenderFns } from "./ToggleReports.vue?vue&type=template&id=0125ae4b&scoped=true&"
import script from "./ToggleReports.vue?vue&type=script&lang=ts&"
export * from "./ToggleReports.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleReports.vue?vue&type=style&index=0&id=0125ae4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0125ae4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0125ae4b')) {
      api.createRecord('0125ae4b', component.options)
    } else {
      api.reload('0125ae4b', component.options)
    }
    module.hot.accept("./ToggleReports.vue?vue&type=template&id=0125ae4b&scoped=true&", function () {
      api.rerender('0125ae4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ToggleReports.vue"
export default component.exports